import React from 'react';
import { Dialog, ElevatedButton } from '@producer/ui-kit';

import styles from './change-plan.modal.module.scss';
type ChangePlanModalProps = {
  title: string;
  description: string;
  onCancel: () => void;
};

export const ChangePlanModal: React.FC<ChangePlanModalProps> = ({
  title,
  description,
  onCancel,
}) => {
  return (
    <Dialog
      title={title}
      onClose={onCancel}
      actions={[<ElevatedButton key="close" text="Close" onClick={onCancel} />]}
    >
      <p
        className={styles['container']}
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />
    </Dialog>
  );
};
